import * as React from 'react'
import { useTranslations } from 'next-intl'
import { useIsAuthenticated } from 'auth/hooks'
import { useUserAuthModal } from 'components/user-auth-dialog/user-auth-dialog-context'
import dynamic from 'next/dynamic'
import { sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'

import { AddAPhoto } from '@web/components/icons/add-a-photo'
import { ButtonIcon } from '../button-icon'
import { shareCreationTrackingEvents } from './tracking/share-creation-tracking-events'

const PostAProjectModal = dynamic(
  () => import('./post-a-project-modal').then(module => module.PostAProjectModal),
  {
    ssr: false,
  },
)

export function PostAProjectButton() {
  const [showUploadCreationsModal, setShowUploadCreationsModal] = React.useState<boolean>(false)
  const isAuthenticated = useIsAuthenticated()
  const { openModal: openUserAuthModal } = useUserAuthModal()
  const t = useTranslations('prod.product_description_page.share_creation')

  const onClickPostProject = React.useCallback(() => {
    sendAmplitudeEvent(shareCreationTrackingEvents.PP_POST_A_PROJECT_BANNER_CLICKED)

    if (isAuthenticated) {
      setShowUploadCreationsModal(true)
    } else {
      openUserAuthModal()
    }
  }, [isAuthenticated, openUserAuthModal, setShowUploadCreationsModal])

  const onCloseModal = React.useCallback(() => {
    setShowUploadCreationsModal(false)
  }, [])

  return (
    <>
      <ButtonIcon icon={<AddAPhoto className="size-4" />} onClick={onClickPostProject}>
        {t('banner.cta')}
      </ButtonIcon>
      <PostAProjectModal onClose={onCloseModal} isOpen={showUploadCreationsModal} />
    </>
  )
}
